import Resource from './base.resource'

export default class StylesResource extends Resource
{
    constructor() {
        super('styles')
    }
}
